"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteInformationInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var CompleteInformationInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CompleteInformationInit, _super);
    function CompleteInformationInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷补全资料初始化接口';
        _this.code = '101117';
        _this.desc = '现金贷补全资料初始化接口';
        _this.requestParams = new cashLoanAuth_1.CompleteInformationInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CompleteInformationInit;
}(service_1.BaseService));
exports.CompleteInformationInit = CompleteInformationInit;
//# sourceMappingURL=completeInformationInit.js.map